import { Box, Button, Grid, List, Stack, Typography } from "@mui/material";
import PostCoordinationDiagnosisAutoComplete from "components/postCoordinationDiagnosisAutoComplete";
import favoriteDiagnosisService from "services/api/favoriteDiagnosis.service";
import useQueryParams from "hooks/useQueryParams";
import { useEncounter } from "pages/encounter/encounter.provider";
import { useFieldArray } from "react-hook-form";
import { ICD10WHO2016 } from "dto/favoriteDiagnosis.dto";
import FavItem from "./favItem";
import SimpleBar from "simplebar-react";
import { useFavorite } from "pages/encounter/favorite.provider";
import NorthIcon from "@mui/icons-material/North";
import SouthIcon from "@mui/icons-material/South";

const FavoriteDiagnosis = () => {
    const { loading } = useEncounter();
    const [doctorLicense] = useQueryParams("recorder");

    const { favoriteForm, handleFavorite, isAscending, sortFavorite } =
        useFavorite();
    const { control, handleSubmit } = favoriteForm;

    const { append, fields, remove, update, swap } = useFieldArray({
        control,
        name: "favoriteList"
    });

    const onSubmit = handleSubmit((value) => {
        if (doctorLicense)
            return favoriteDiagnosisService.update(
                doctorLicense,
                value.favoriteList
            );
    });

    if (loading) {
        return <Box>Loading...</Box>;
    }

    if (!doctorLicense) {
        return (
            <Box>
                <Typography variant="h5">
                    Please set a doctor before use favorite diagnosis
                </Typography>
            </Box>
        );
    }

    return (
        <>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <PostCoordinationDiagnosisAutoComplete
                        resetOnSelect
                        disabledFreeText
                        setState={(value) => {
                            if (value) {
                                append({
                                    term: value.keyword,
                                    stack: value.stack,
                                    conceptId: value.conceptId,
                                    icd10: value.icd,
                                    version: ICD10WHO2016,
                                    counter: 0
                                });
                                setTimeout(onSubmit, 300);
                            }
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Box
                        component={SimpleBar}
                        sx={{
                            height: "calc(100vh - 360px)",
                            overflow: "auto"
                        }}
                    >
                        <Stack direction={"row"} justifyContent={"end"}>
                            <Button
                                variant="contained"
                                size="small"
                                color="primary"
                                onClick={sortFavorite}
                                endIcon={
                                    <Box display="flex" alignItems="center">
                                        {isAscending ? (
                                            <SouthIcon
                                                sx={{
                                                    color: "#FFF",
                                                    fontSize: "1.2rem"
                                                }}
                                            />
                                        ) : (
                                            <NorthIcon
                                                sx={{
                                                    color: "#FFF",
                                                    fontSize: "1.2rem"
                                                }}
                                            />
                                        )}
                                    </Box>
                                }
                            >
                                Sort by name
                            </Button>
                        </Stack>
                        <List>
                            {fields.map((field, index) => (
                                <FavItem
                                    key={field.id}
                                    field={field}
                                    updateIncrement={() => {
                                        update(index, {
                                            ...field,
                                            counter: (field.counter ?? 0) + 1
                                        });
                                        setTimeout(onSubmit, 300);
                                    }}
                                    remove={() => {
                                        remove(index);
                                        handleFavorite(field);
                                        setTimeout(onSubmit, 300);
                                    }}
                                    disabledDown={index === fields.length - 1}
                                    disabledUp={index === 0}
                                    swapDown={() => {
                                        swap(index, index + 1);
                                    }}
                                    swapUp={() => {
                                        swap(index, index - 1);
                                    }}
                                />
                            ))}
                        </List>
                    </Box>
                </Grid>
            </Grid>
        </>
    );
};

export default FavoriteDiagnosis;
